import { FC } from 'react';

import { Grid } from '@mui/material';

import { SubNavigation } from 'src/components';
import { PRODUCT_AND_PRICING_OFFERINGS_SUB_NAVIGATION } from 'src/constants';
import { PricingType } from 'src/hooks/usePricings';

interface ProductAndPricingOfferingsProps {
    offerList: OfferList;
    transactionPricingOfferList?: TransactionPricingOfferList;
}

type Offer = {
    id: number;
    name: string;
    type: string;
    createdAt: string;
};

type TransactionPricingOffer = {
    id: number;
    offerName: string;
    createdAt: string;
    status: string;
};

export type OfferList = Offer[];
export type TransactionPricingOfferList = TransactionPricingOffer[];

const ProductAndPricingOfferings: FC<ProductAndPricingOfferingsProps> = ({
    offerList,
    transactionPricingOfferList,
}) => {
    const combinedOffers: Offer[] = transactionPricingOfferList.length
        ? mergePricingOffers(offerList, transactionPricingOfferList)
        : offerList;

    return (
        <Grid sx={{ display: 'flex', flexDirection: 'column', maxWidth: '100%' }}>
            <SubNavigation
                isProductAndPricing
                steps={PRODUCT_AND_PRICING_OFFERINGS_SUB_NAVIGATION}
                offerList={combinedOffers}
            />
        </Grid>
    );
};

const mergePricingOffers = (
    offerList: Offer[],
    transactionPricingOfferList: TransactionPricingOffer[]
): Offer[] => {
    const combinedOffers: Offer[] = [...offerList];

    transactionPricingOfferList.forEach((transactionOffer) => {
        const newOffer: Offer = {
            id: transactionOffer.id,
            name: transactionOffer.offerName,
            type: PricingType.TRANSACTIONAL,
            createdAt: transactionOffer.createdAt,
        };

        combinedOffers.push(newOffer);
    });

    return combinedOffers;
};

export default ProductAndPricingOfferings;
